import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import toast from 'react-hot-toast';
import '../styles/UpdateTool.css';

const UpdateTool = () => {
    const [tool, setTool] = useState({
        tool_name: '',
        tool_model: '',
        tool_location: '',
        tool_category: '',
        imageUrl: '',
        restriction: ''
    });

    const [error, setError] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Fetch the tool data
    useEffect(() => {
        const fetchTool = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/tools/${id}`, {});
                setTool(response.data);
            } catch (err) {
                setError(err.response ? err.response.data.message : 'Error fetching tool data');
            }
        };
        fetchTool();
    }, [id, API_URL]);

    // Handle form changes
    const handleChange = (e) => {
        setTool({ ...tool, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(`${API_URL}/api/tools/${id}`, {
                tool_name: tool.tool_name,
                tool_model: tool.tool_model,
                tool_location: tool.tool_location,
                tool_category: tool.tool_category,
                imageUrl: tool.imageUrl,
                restriction: tool.restriction,
                list_of_trained_students: tool.list_of_trained_students
            }, {});
            
            if (response.data) {
                navigate(`/tool/${id}`);
                toast.success('Tool updated successfully!', {
                    iconTheme: {
                        primary: '#333',
                        secondary: '#DCB41F',
                    },
                    style: {
                        backgroundColor: '#333',
                        color: '#DCB41F',
                    },
                });
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Error updating tool');
            toast.error('Error updating tool', {
                iconTheme: {
                    primary: '#FFFFFF',
                    secondary: '#E61920',
                },
                style: {
                    backgroundColor: '#E61920',
                    color: '#FFFFFF',
                },
            });
        }
    };

    // Handle form cancel
    const handleCancel = () => {
        navigate('/edit-tools');
        toast('No changes were made.', {
            iconTheme: {
                primary: '#333',
                secondary: '#DCB41F',
            },
            style: {
                backgroundColor: '#333',
                color: '#DCB41F',
            },
        });
    };

    return (
        <div>
            <Header />
            <div className="update-tool-container">
                <h2>Update Tool</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
    <input placeholder="Tool Name" type="text" name="tool_name" value={tool.tool_name} onChange={handleChange} required />
    <input placeholder="Tool Model" type="text" name="tool_model" value={tool.tool_model} onChange={handleChange} required />
    <input placeholder="Tool Location" type="text" name="tool_location" value={tool.tool_location} onChange={handleChange} required />
    <input placeholder="Tool Category" type="text" name="tool_category" value={tool.tool_category} onChange={handleChange} required />
    <input placeholder="Image URL" type="text" name="imageUrl" value={tool.imageUrl} onChange={handleChange} required />
    
    <select name="restriction" value={tool.restriction} onChange={handleChange} required>
        <option value="safe">Safe (No supervision needed)</option>
        <option value="cautious">Cautious (Adult supervision needed)</option>
        <option value="danger">Danger (Not allowed)</option>
    </select>

    <div className="button-group">
        <button type="submit">Update Tool</button>
        <button type="button" onClick={handleCancel}>Cancel</button>
    </div>
</form>
            </div>
        </div>
    );
};

export default UpdateTool;
